<script>

export default {
  name: "quotation",
  data() {
    return{
      year:(new Date()).getFullYear()
    }
  }
}
</script>

<template>
<div class="footer-box">航天联志技术有限公司 1999-{{year}} © ALL RIGHTS RESERVED</div>
</template>

<style scoped lang="scss">
.footer-box{
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: #951D1D;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue